// extracted by mini-css-extract-plugin
export default {"wrapper":"Thanks_wrapper__Ly2tZ","icon":"Thanks_icon__08XHu","title":"Thanks_title__-NBbA","text":"Thanks_text__MBnKO","subtext":"Thanks_subtext__WMb1D"};